// Modules
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import PropTypes from 'prop-types';
// Components
import ConsultationForm from '../ConsultationForm/ConsultationForm';
// Helpers
import checkRtlLanguage from '../../../utils/checkRtlLanguage';

class ConsultationBlock extends Component {
  state = {
    captcha: null
  };

  fetchReCaptchaToken = (token) => {
    this.setState({ captcha: token });
  }

  handleSubmit = (values) => {
    const { captcha } = this.state;

    if (!captcha) {
      console.warn('Captcha is missing');
      return;
    }

    this.props.onSubmit({ ...values, captcha });
  }

  render() {
    const {
      field_id,
      companyName,
      className,
      translate,
      isRtl,
      formSubmitting,
      formSubmitted,
      formConsultationError,
      isCommunityMember
    } = this.props;

    return (
       <ConsultationForm
         fetchReCaptchaToken={this.fetchReCaptchaToken}
         locale={this.props.locale}
         field_id={field_id}
         companyName={companyName}
         className={className}
         translate={translate}
         onSubmit={this.handleSubmit}
         isRtl={isRtl}
         formSubmitting={formSubmitting}
         formSubmitted={formSubmitted}
         formConsultationError={formConsultationError}
         isCommunityMember={isCommunityMember}
         captcha={this.state.captcha}
       />
    );
  }
}

ConsultationBlock.propTypes = {
  locale: PropTypes.string,
  field_id: PropTypes.string,
  companyName: PropTypes.string,
  className: PropTypes.string,
  translate: PropTypes.func,
  onSubmit: PropTypes.func,
  isRtl: PropTypes.bool,
  formSubmitted: PropTypes.bool,
  formSubmitting: PropTypes.bool,
  formConsultationError: PropTypes.object,
  isCommunityMember: PropTypes.bool
};

const mapStateToProps = (state) => ({
  locale: state.lang.locale,
  isRtl: checkRtlLanguage(state.lang.locale),
  translate: getLang(state.lang, 'static')
});

export default connect(mapStateToProps)(ConsultationBlock);
